import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import TestimonialsHero from './components/TestimonialsHero';
import TestimonialsCards from './components/TestimonialsCards';
import TestimonialsCategories from './components/TestimonialsCategories';
import TestimonialsStats from './components/TestimonialsStats';
import { useTitle } from '@/hooks/useTitle';

import PageCta from '@/components/feature/PageCta';

export default function Testimonials() {
  useTitle({
    title: '客戶見證｜保險建築師真實案例與推薦',
    description: '閱讀保險建築師客戶的真實評價與保障規劃案例，了解我們如何協助不同家庭建立穩固的保障結構。',
  });
  return (
    <main>
      <Navbar />
      <TestimonialsHero />
      <TestimonialsCards />
      <TestimonialsCategories />
      <TestimonialsStats />
      <PageCta />
      <Footer />
    </main>
  );
}
